export const selectAuthState = state => state.auth;
export const selectAuthenticatedUser = state => state.auth.user;